import { useState, type FormEvent } from "react";
import { useWorkspace } from "../features/workspace-context";

export function LoginPage() {
  const { signIn, signUp, error } = useWorkspace();
  const [mode, setMode] = useState<"signin" | "signup">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setMessage(null);
    try {
      if (mode === "signin") {
        await signIn(email, password);
      } else {
        setMessage(await signUp(email, password, displayName));
      }
    } catch {
      // The provider exposes the safe error message.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <section className="auth-visual">
        <div className="auth-grid" aria-hidden="true" />
        <span className="eyebrow">EremosHub · control de proyectos</span>
        <h1>Convierte la visión en evidencia visible.</h1>
        <p>
          Roadmaps jerárquicos, progreso ponderado, dependencias, historial append-only y enlaces
          técnicos, sin mezclar gestión con la base operativa del motor cuantitativo.
        </p>
        <div className="auth-constellation" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
        </div>
      </section>
      <section className="auth-panel">
        <div className="auth-card">
          <div className="brand brand--auth">
            <span className="brand__mark">E</span>
            <span>
              <strong>EREMOS</strong>
              <small>PROJECT COMMAND</small>
            </span>
          </div>
          <span className="eyebrow">Acceso seguro</span>
          <h2>{mode === "signin" ? "Iniciar sesión" : "Crear cuenta"}</h2>
          <p className="muted">
            Supabase Auth identifica al usuario; PostgreSQL RLS decide qué puede ver o modificar.
          </p>
          <form className="form-stack" onSubmit={(event) => void submit(event)}>
            {mode === "signup" && (
              <label>
                Nombre visible
                <input
                  required
                  value={displayName}
                  onChange={(event) => setDisplayName(event.target.value)}
                  autoComplete="name"
                />
              </label>
            )}
            <label>
              Correo
              <input
                required
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
              />
            </label>
            <label>
              Contraseña
              <input
                required
                minLength={8}
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete={mode === "signin" ? "current-password" : "new-password"}
              />
            </label>
            {(error || message) && (
              <div className={error ? "notice notice--error" : "notice notice--success"}>
                {error ?? message}
              </div>
            )}
            <button className="button button--primary" disabled={submitting} type="submit">
              {submitting ? "Procesando…" : mode === "signin" ? "Entrar" : "Crear cuenta"}
            </button>
          </form>
          <button
            className="text-button"
            type="button"
            onClick={() => setMode(mode === "signin" ? "signup" : "signin")}
          >
            {mode === "signin" ? "¿Primera vez? Crear cuenta" : "Ya tengo cuenta"}
          </button>
        </div>
      </section>
    </div>
  );
}
